export default __webpack_public_path__ + "static/2018_2019_WVS INDIA CONSOLIDATED ACCOUNTS-007d3b1037d913f7c66e10c0c8538f84.pdf";